// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"252":"637ef72b","660":"8369cf52"}[chunkId] + ".chunk.css");